import * as yup from 'yup';
import { useCaptchaTokenValidation, usePhoneValidation } from '@form';

export const useValidation = () => {
  const phoneValidation = usePhoneValidation();
  const tokenValidation = useCaptchaTokenValidation();

  return yup.object().shape({
    ...phoneValidation,
    ...tokenValidation,
  });
};
